Vue.component('content-how', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div
            class="row"
            data-custom-animations="true"
            data-ca-options='{"triggerHandler":"inview", "animationTarget":"all-childs", "duration":"1600", "delay":"160", "easing":"easeOutQuint", "initValues":{"translateY": 100, "opacity":0}, "animations":{"translateY": 0, "opacity":1}}'>

                <div class="lqd-column col-md-12 mb-60">
                    <header class="fancy-title text-uppercase" id="thisTitleId">
                        <h6
                        class="font-size-20 ltr-sp-01"
                        data-split-text="true"
                        data-custom-animations="true"
                        data-ca-options='{"triggerHandler":"inview", "animationTarget":".split-inner", "duration":"1600", "delay":100, "easing":"easeOutQuint", "direction":"forward", "initValues":{"translateY":60}, "animations":{"translateY":0}}'
                        data-split-options='{"type":"lines"}'>
                            <span class="ld-fh-txt"> What is <span class="sq-font">SpartaQuant</span>?</span>
                        </h6>
                        <!-- <h2><strong>What is <span class="sq-font">SpartaQuant</span> ?</strong></h2> -->
                    </header>
                    <p class="font-size-25 lh-15 mb-25">
                        <h3><span class="sq-font" style='color:black;'>SpartaQuant</span> is a low code platform with two objectives:</h3>
                        <p class="font-size-18 lh-15 mb-25">1. To accelerate the development of Python applications using a proprietary ecosystem</p>
                        <p class="font-size-18 lh-15 mb-25">2. To provide a customizable interface for decision makers</p>
                    </p>
                    <!-- <p class="font-size-18 lh-15 mb-25"><span class="sq-font" style='color:black;'>SpartaQuant</span> is a software that helps you to manipulate data, build indicators and models as easy as possible and provides end user tools</p>
                    <p class="font-size-18 lh-15 mb-25">A good use case is for the daily job of analysts as <span class="sq-font" style='color:black;'>SpartaQuant</span> provides statistics, econometrics and machine learning models.<br><strong style='color:#3f51b5'>No coding skills are required</strong></p>
                    <p class="font-size-18 lh-15 mb-25">For more flexibility, we also enable people to develop their own scripts and functions within the platform, using the most advanced available technologies</p>
                    <p class="font-size-18 lh-15 mb-25">Check out our marketplace and find many useful scripts and modules</p>
                    <br> -->

                    <section class="vc_row pt-50 pb-50">
                        <div class="container">
                            <div class="row">
                                <div class="lqd-column col-md-4" style='height:250px;'>
                                    <div class="iconbox iconbox-shadow-hover" style='background:rgb(63, 81, 181, 0.3); height:100%;'>
                                        <div class="iconbox-icon-wrap">
                                            <span class="iconbox-icon-container">
                                                <i class="fa fa-code" style='color:rgb(63, 81, 181);'></i>
                                            </span>
                                        </div><!-- /.iconbox-icon-wrap -->
                                        <div class="contents" style='color:rgb(63, 81, 181)'>
                                            <h3 class="font-weight-bold" style='color:rgb(63, 81, 181);'>Developers</h3>
                                            <p>Lightspeed Python development platform</p>
                                            <!-- <a href="#" class="btn btn-naked" style='color:rgb(63, 81, 181);'>
                                                <span>
                                                    <span class="btn-txt">Lean More</span>
                                                    <span class="btn-icon"><i class="fa fa-angle-right"></i></span>
                                                </span>
                                            </a> -->
                                        </div><!-- /.contents -->
                                    </div><!-- /.iconbox -->
                                </div><!-- /.col-md-4 -->

                                <div class="lqd-column col-md-4" style='height:250px; border:solid 1px #dcdcdc;'>
                                    <div class="iconbox">
                                        <div class="contents" style='text-align:center; padding-top:50px;'>
                                            <img src="./assets/img/spartaquant/icon-color.png" width="200px" alt="SpartaQuant icon" class="logo-default">
                                            <h3><span class="sq-font" style='color:black;'>SpartaQuant</span></h3>
                                        </div><!-- /.contents -->
                                    </div><!-- /.iconbox -->
                                </div><!-- /.col-md-4 -->

                                <div class="lqd-column col-md-4" style='height:250px;'>
                                    <div class="iconbox iconbox-shadow-hover iconbox-filled bg-old-lace" style='height:100%;'>
                                        <div class="iconbox-icon-wrap">
                                            <span class="iconbox-icon-container text-neon-carrot">
                                                <i class="fa fa-line-chart"></i>
                                            </span>
                                        </div><!-- /.iconbox-icon-wrap -->
                                        <div class="contents text-neon-carrot">
                                            <h3 class="font-weight-bold text-neon-carrot">Decision makers</h3>
                                            <p>No code platform for decision makers</p>
                                            <!-- <a href="#" class="btn btn-naked text-neon-carrot">
                                                <span>
                                                    <span class="btn-txt">Lean More</span>
                                                    <span class="btn-icon"><i class="fa fa-angle-right"></i></span>
                                                </span>
                                            </a> -->
                                        </div><!-- /.contents -->
                                    </div><!-- /.iconbox -->
                                </div><!-- /.col-md-4 -->
                            </div><!-- /.row -->
                        </div><!-- /.container -->
                    </section>

                    <section>
                        <div class="container">
                            <div class="row">
                                <div class="lqd-column col-lg-10 col-lg-offset-1">

                                    <div class="tabs-nav-justified tabs-nav-underlined tabs-nav-active-underlined">
                                        <ul class="nav tabs-nav" role="tablist">
                                            <li role="presentation" class="h5 active">
                                                <a href="#ld-tab-pane-5" aria-expanded="false" aria-controls="ld-tab-pane-5" role="tab" data-toggle="tab" style='color:rgb(63, 81, 181);'>
                                                    <span class="tabs-nav-icon">
                                                        <i class="fa fa-code"></i>
                                                    </span>
                                                    Developers
                                                </a>
                                            </li>
                                            <li role="presentation" class="h5">
                                                <a href="#ld-tab-pane-6" aria-expanded="false" aria-controls="ld-tab-pane-6" role="tab" data-toggle="tab" class="text-neon-carrot">
                                                    <span class="tabs-nav-icon text-neon-carrot">
                                                        <i class="fa fa-line-chart"></i>
                                                    </span>
                                                    Decision makers
                                                </a>
                                            </li>
                                        </ul>
                                        <div class="tabs-content">
                                            <div id="ld-tab-pane-5" role="tabpanel" class="tabs-pane fade active in">
                                                <li>
                                                    <span class="sq-font" style='color:black;'>SpartaQuant</span> facilitates the development of all your Python applications
                                                </li>
                                                <li style='margin-top:15px'>
                                                    Create your own modules using the proprietary <span style='color:black; font-weight:bold;'>Quant calculator</span> and manage your development environment
                                                </li>
                                                <li style='margin-top:15px'>
                                                    You will find plenty of ready-to-use modules and applications that can be tested and used in a low code framework
                                                </li>
                                                <li style='margin-top:15px'>
                                                    <span class="sq-font" style='color:black;'>SpartaQuant</span> allows you to quick test libraries and access existing modules and objects in a few clicks  
                                                </li>
                                                <li style='margin-top:15px'>
                                                    A marketplace is available where you will find novel applications and access the source code if needed 
                                                </li>
                                                <li style='margin-top:15px'>
                                                    All the <span class="sq-font" style='color:black;'>SpartaQuant</span> objects and functions are available through a public <a href="https://spartaquant.pro/publicAPI">API</a>
                                                </li>
                                            </div><!-- /.tab-pane -->
                                            <div id="ld-tab-pane-6" role="tabpanel" class="tabs-pane fade">
                                                <li>
                                                    <span class="sq-font" style='color:black;'>SpartaQuant</span> provides an intuitive and customizable interface for decision makers
                                                </li>
                                                <li style='margin-top:15px'>
                                                    All the applications provided by developers are accessible to decision makers in <span style='color:black; font-weight:bold;'>no code environment</span> 
                                                </li>
                                                <li style='margin-top:15px'>
                                                    Those business applications are as intuitive to use as are mobile applications
                                                    </li>   
                                                <li style='margin-top:15px'>
                                                    <span class="sq-font" style='color:black;'>SpartaQuant</span> allows you to build and share <span style='color:black; font-weight:bold;'>dashboards</span> in a few clicks through drag and drop  
                                                </li>
                                                <li style='margin-top:15px'>
                                                    You can automatize your daily tasks and set alerts using <span class="sq-font" style='color:black;'>SpartaQuant</span> <span style='color:black; font-weight:bold;'>scheduler</span> 
                                                </li>
                                                <li style='margin-top:15px'>
                                                    Decisions are taken in a common and collaborative environment
                                                </li>
                                            </div><!-- /.tab-pane -->
                                        </div><!-- /.tabs-content -->
                                    </div><!-- /.tabs -->

                                    <hr class="mt-100">

                                </div><!-- /.lqd-column col-lg-8 col-lg-offset-2 -->

                            </div><!-- /.row -->
                        </div><!-- /.container -->
                    </section>
                    <!-- <div style='display:block; width:100%; text-align:center'>
                        <div id="venn" style='display:block; margin:auto;'></div>
                    </div> -->
                    <!-- <div
                        class="liquid-img-container-inner"
                        data-parallax="true"
                        data-parallax-from='{"translateY":0}'
                        data-parallax-to='{"translateY":0}'
                        data-parallax-options='{"overflowHidden":false,"easing":"linear"}'>
                        <img src="./assets/img/spartaquant/venn.png" alt="Laptop" style='display:block; margin:auto; width:50%'/>
                    </div> -->
                </div><!-- /.lqd-column col-md-12 -->

                <div class="lqd-column col-md-4">
                    <div class="iconbox text-left iconbox-xl iconbox-icon-image iconbox-shadow border-radius-5 px-5 pt-40 pb-55 mr-md-4">
                        <div class="iconbox-icon-wrap">
                            <span class="iconbox-icon-container mb-35">
                                <i class="fa fa-code"></i>
                            </span>
                        </div><!-- /.iconbox-icon-wrap -->
                        <div class="contents">
                            <h3>1. Develop</h3>
                            <li><span style="font-size: 16px;line-height: 20px">Python development facilitated</span></li>
                            <li><span style="font-size: 16px;line-height: 20px"><span class="sq-font" style='color:black;'>SpartaQuant</span> <a href="https://www.spartaquant.pro/publicAPI">API</a></span></li>
                            <li><span style="font-size: 16px;line-height: 20px">Integrated database</span></li>
                            <li><span style="font-size: 16px;line-height: 20px">Database connection to external sources and xls files</span></li>
                        </div><!-- /.contants -->
                    </div><!-- /.iconbox -->
                </div><!-- /.lqd-column col-md-4 -->

                <div class="lqd-column col-md-4">
                    <div class="iconbox text-left iconbox-xl iconbox-icon-image iconbox-shadow border-radius-5 px-5 pt-40 pb-55 mx-md-2">
                        <div class="iconbox-icon-wrap">
                            <span class="iconbox-icon-container mb-35">
                                <i class="fa fa-wrench"></i>
                            </span>
                        </div><!-- /.iconbox-icon-wrap -->
                        <div class="contents">
                            <h3>2. Test</h3>
                            <li><span style="font-size: 16px;line-height: 20px">Quick test using our <span style='color:black; font-weight:bold;'>Quant calculator</span></span></li>
                            <li><span style="font-size: 16px;line-height: 20px">Data cleansing facilitated</span></li>
                            <li><span style="font-size: 16px;line-height: 20px">Plenty of models available (no coding) through a marketplace</span></li>
                        </div><!-- /.contants -->
                    </div><!-- /.iconbox -->
                </div><!-- /.lqd-column col-md-4 -->

                <div class="lqd-column col-md-4">
                    <div class="iconbox text-left iconbox-xl iconbox-icon-image iconbox-shadow border-radius-5 px-5 pt-40 pb-55 ml-md-4">
                        <div class="iconbox-icon-wrap">
                            <span class="iconbox-icon-container mb-35">
                                <i class="fa fa-pie-chart"></i>
                            </span>
                        </div><!-- /.iconbox-icon-wrap -->
                        <div class="contents">
                            <h3>3. Create dashboards</h3>
                            <li><span style="font-size: 16px;line-height: 20px">Create your own Dashboards in few clicks</span></>
                            <li><span style="font-size: 16px;line-height: 20px">Share with your team members</span></>
                            <li><span style="font-size: 16px;line-height: 20px">Schedule tasks and set alerts and emails</span></li>
                        </div><!-- /.contants -->
                    </div><!-- /.iconbox -->
                </div><!-- /.lqd-column col-md-4 -->

            </div><!-- /.row -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
            sets: [],
            colours: [],
            chart: null,
        }
    },
    mounted(){
        // this.setVenn();
        var _this = this;
        $(window).resize(function() {
            _this.resizeScreenSize();
        }); 
    },
    methods: {
        setSets: function(){
            this.sets = [
                {sets: ['A'], size: 80, label:"Modelisation", subtext:"Python, Matlab, Java, SQL</br>Powerful and technical", color:"#77BCFD"},
                {sets: ['B'], size: 80, label:"Automation", subtext:"Push your code to prod</br>Update your templates<br>Create dashboards", color:"#FF9800"},
                {sets: ['C'], size: 80, label:"Data", subtext:"Collect data using APIs<br>Work with Excel and SQL Databases", color:"#3F51B5"},
                {sets: ['A','B'], size: 20, subtext:""},
                {sets: ['A','C'], size: 20, subtext:""},
                {sets: ['B','C'], size: 20, subtext:""},
                {sets: ['A','B','C'], size: 30, label:"SPARTAQUANT", subtext:"No coding skills<br>No limitations", color:"#FFFFFF"}
            ];
        },
        setColors: function(){
            this.colours = ['#77BCFD', '#FF9800', '#3F51B5', 'green'];
        },
        // annotateSizes: function(thisSel){
        //     // d3.select(this).select("text")
        //     //     .append("tspan")
        //     //     .text(function(d) { return d.subtext; })
        //     //     .attr("x", function() { return d3.select(this.parentNode).attr("x"); })
        //     //     .attr("dy", "1.5em")
        //     //     .style("font-size", "17px");
        //     var _this = this;
        //     console.log("this sel")
        //     console.log(thisSel)
        //     thisSel = thisSel[0]
        //     d3.select([thisSel]).append("foreignObject")
        //         .attr({
        //             height: 120,
        //             width: 400, // dimensions determined based on need
        //             transform: 'translate(0,0)' // put it where you want it...
        //         })
        //         .text(function(d) { return d.subtext; })
        //         .attr("x", function() { return (parseInt(d3.select(thisSel.parentNode).select("text").attr("x"))-200).toString(); })
        //         .attr("y", function(d) { 
        //             if(d._this.sets.length == 1 && d._this.sets[0] == 'C'){
        //                 var thisYPosition = parseInt(d3.select(thisSel.parentNode).select("text").attr("y"));
        //                 d3.select(thisSel.parentNode).select("text").attr("y",(thisYPosition+30).toString())
        //                 return (thisYPosition+5).toString(); 
        //             }
        //             return (parseInt(d3.select(thisSel.parentNode).select("text").attr("y"))-25).toString(); 
        //         })
        //         .attr("dy", "2.5em")
        //         .style("font-size", "17px")
        //         .style("color", "white")
        //         .style("color", function(d) { return d.color; })
        //         .html(function(d) { return d.subtext; })
        //         //.html('<div class"style-me"><p>My label or other text</p></div>');
        // },
        updateVenn: function(){

            function annotateSizes() {
                // d3.select(this).select("text")
                //     .append("tspan")
                //     .text(function(d) { return d.subtext; })
                //     .attr("x", function() { return d3.select(this.parentNode).attr("x"); })
                //     .attr("dy", "1.5em")
                //     .style("font-size", "17px");
                
                d3.select(this).append("foreignObject")
                    .attr({
                        height: 120,
                        width: 400, // dimensions determined based on need
                        transform: 'translate(0,0)' // put it where you want it...
                    })
                    .text(function(d) { return d.subtext; })
                    .attr("x", function() { return (parseInt(d3.select(this.parentNode).select("text").attr("x"))-200).toString(); })
                    .attr("y", function(d) { 
                        if(d.sets.length == 1 && d.sets[0] == 'C'){
                            var thisYPosition = parseInt(d3.select(this.parentNode).select("text").attr("y"));
                            d3.select(this.parentNode).select("text").attr("y",(thisYPosition+30).toString())
                            return (thisYPosition+5).toString(); 
                        }
                        return (parseInt(d3.select(this.parentNode).select("text").attr("y"))-25).toString(); 
                    })
                    .attr("dy", "2.5em")
                    .style("font-size", "17px")
                    .style("color", "white")
                    .style("color", function(d) { return d.color; })
                    .html(function(d) { return d.subtext; })
                    //.html('<div class"style-me"><p>My label or other text</p></div>');
            }     

            var div = d3.select("#venn").datum(this.sets);
            var layout = this.chart(div),
                textCentres = layout.textCentres;
            div.selectAll(".label").style("fill", "white");
            div.selectAll(".label").style("font-size", "27px");
            div.selectAll(".venn-circle path").style("fill-opacity", .3);
            div.selectAll(".label").attr({
                "dy": -30,
                "class": "myClass"
                // "transform": "translate(" + 5 + "," + 5 + ")"
                })
            
            div.selectAll("g").transition("venn").each("end", annotateSizes).duration(0);
           
            // var _this = this;
            // div.selectAll("g").transition("venn").each(function(){
            //     console.log("test")
            //     console.log($(this))
            //     _this.annotateSizes($(this)).duration(0);
            // }),
            
            var _this = this;
            div.selectAll(".venn-circle path")
            .style("fill-opacity", 0.5)
            .style("stroke-width", 2)
            .style("stroke-opacity", 0.5)
            .style("fill", function(d,i) { return _this.colours[i]; })
            .style("stroke", function(d,i) { return _this.colours[i]; });
                
            return layout;
        },
        setVenn: function(){
            // var sets = [
            //     {sets: ['A'], size: 80, label:"Modelisation", subtext:"Python, Matlab, Java, SQL</br>Powerful and technical", color:"#77BCFD"},
            //     {sets: ['B'], size: 80, label:"Automation", subtext:"Push your code to prod</br>Update your templates<br>Create dashboards", color:"#FF9800"},
            //     {sets: ['C'], size: 80, label:"Data", subtext:"Collect data using APIs<br>Work with Excel and SQL Databases", color:"#3F51B5"},
            //     {sets: ['A','B'], size: 20, subtext:""},
            //     {sets: ['A','C'], size: 20, subtext:""},
            //     {sets: ['B','C'], size: 20, subtext:""},
            //     {sets: ['A','B','C'], size: 30, label:"SPARTAQUANT", subtext:"No coding skills<br>No limitations", color:"#FFFFFF"}
            // ];

            this.setSets();
            this.setColors();

            var width = $('#thisTitleId').width();
            var height = $('#thisTitleId').height();
            

            var _this = this;
            this.chart = venn.VennDiagram()
                .wrap(false)
                .fontSize("16px")
                .width(width)
                .height(640);

                
            // function annotateSizes() {
            //     // d3.select(this).select("text")
            //     //     .append("tspan")
            //     //     .text(function(d) { return d.subtext; })
            //     //     .attr("x", function() { return d3.select(this.parentNode).attr("x"); })
            //     //     .attr("dy", "1.5em")
            //     //     .style("font-size", "17px");
                
            //     d3.select(this).append("foreignObject")
            //         .attr({
            //             height: 120,
            //             width: 400, // dimensions determined based on need
            //             transform: 'translate(0,0)' // put it where you want it...
            //         })
            //         .text(function(d) { return d.subtext; })
            //         .attr("x", function() { return (parseInt(d3.select(this.parentNode).select("text").attr("x"))-200).toString(); })
            //         .attr("y", function(d) { 
            //             if(d.sets.length == 1 && d.sets[0] == 'C'){
            //                 var thisYPosition = parseInt(d3.select(this.parentNode).select("text").attr("y"));
            //                 d3.select(this.parentNode).select("text").attr("y",(thisYPosition+30).toString())
            //                 return (thisYPosition+5).toString(); 
            //             }
            //             return (parseInt(d3.select(this.parentNode).select("text").attr("y"))-25).toString(); 
            //         })
            //         .attr("dy", "2.5em")
            //         .style("font-size", "17px")
            //         .style("color", "white")
            //         .style("color", function(d) { return d.color; })
            //         .html(function(d) { return d.subtext; })
            //         //.html('<div class"style-me"><p>My label or other text</p></div>');
            // }     

            // function updateVenn(sets) {
            //     var div = d3.select("#venn").datum(sets);
            //     var layout = _this.chart(div),
            //         textCentres = layout.textCentres;
            //     div.selectAll(".label").style("fill", "white");
            //     div.selectAll(".label").style("font-size", "27px");
            //     div.selectAll(".venn-circle path").style("fill-opacity", .3);
            //     div.selectAll(".label").attr({
            //         "dy": -30,
            //         "class": "myClass"
            //         // "transform": "translate(" + 5 + "," + 5 + ")"
            //       })
            //     div.selectAll("g").transition("venn").each("end", annotateSizes).duration(0);
                
            //     div.selectAll(".venn-circle path")
            //     .style("fill-opacity", 0.5)
            //     .style("stroke-width", 2)
            //     .style("stroke-opacity", 0.5)
            //     .style("fill", function(d,i) { return colours[i]; })
            //     .style("stroke", function(d,i) { return colours[i]; });
                    
            //     return layout;
            // }

            // function responsiveNessVenn(){

            //     width = $('.chart-container').width();
            //     height = $('.chart-container').height();

            //     d3.select("#venn")
            //         .append("div")
            //         // Container class to make it responsive.
            //         .classed("svg-container", true) 
            //         .append("svg")
            //         // Responsive SVG needs these 2 attributes and no width and height attr.
            //         .attr("preserveAspectRatio", "xMinYMin meet")
            //         .attr("viewBox", "0 0 "+width+" "+height)
            //         // Class to make it responsive.
            //         .classed("svg-content-responsive", true)
            //         // Fill with a rectangle for visualization.
            //         .append("rect")
            //         .classed("rect", true)
            //         .attr("width", '100%')
            //         .attr("height", '100%')
            //         .attr('viewBox','0 0 '+Math.min(width,height)+' '+Math.min(width,height))
            //         .append("g")
            //         .attr("transform", "translate(" + Math.min(width,height) / 2 + "," + Math.min(width,height) / 2 + ")");
                    

            //     // var svg = d3.select('#venn').append("svg")
            //     //     .attr("width", '100%')
            //     //     .attr("height", '100%')
            //     //     .attr('viewBox','0 0 '+Math.min(width,height)+' '+Math.min(width,height))
            //     //     .attr('preserveAspectRatio','xMinYMin')
            //     //     .append("g")
            //     //     .attr("transform", "translate(" + Math.min(width,height) / 2 + "," + Math.min(width,height) / 2 + ")");

            // }

            //responsiveNessVenn();

            this.updateVenn();
        },
        resizeScreenSize: function(){
            $("#venn").html('');
            // console.log("resize screen now");
            var width = $('#thisTitleId').width();
            this.chart = venn.VennDiagram()
                .wrap(false)
                .fontSize("16px")
                .width(width)
                .height(640);

            this.updateVenn();
        }

    },
});